<div class="view-wrapper">

  <!-- Toolbar -->
  <nb-card class="profile-toolbar glass-card">
    <nb-card-header class="toolbar-header">
      <span class="header-text">
        <nb-icon icon="person-outline" status="primary"></nb-icon>
        <span>User Profile</span>
      </span>

      <div class="toolbar-actions">
        <!-- ✅ Theme toggle -->


        <button nbButton status="info" size="small" *ngIf="!isEditMode" (click)="editProfile()">
          <nb-icon icon="edit-outline"></nb-icon> Edit
        </button>

        <button nbButton status="basic" outline size="small" *ngIf="isEditMode" (click)="cancel()">
          Cancel
        </button>

        <button nbButton status="primary" size="small" *ngIf="isEditMode" (click)="save()" [disabled]="!isDataChanged">
          <nb-icon icon="save-outline"></nb-icon> Save
        </button>
      </div>
    </nb-card-header>
  </nb-card>

  <!-- ✅ Skeleton Loader -->
  <div *ngIf="isLoading" class="skeleton-wrap">
    <div class="skeleton-card">
      <div class="sk-line w40"></div>
      <div class="sk-line w90"></div>
      <div class="sk-line w70"></div>
    </div>

    <div class="skeleton-card">
      <div class="sk-row">
        <div class="sk-avatar"></div>
        <div class="sk-col">
          <div class="sk-line w50"></div>
          <div class="sk-line w80"></div>
          <div class="sk-line w30"></div>
        </div>
      </div>
      <div class="sk-grid">
        <div class="sk-input"></div>
        <div class="sk-input"></div>
        <div class="sk-input"></div>
        <div class="sk-input"></div>
      </div>
    </div>
  </div>

  <!-- Scrollable Content -->
  <div class="view-wrapper-scroll" *ngIf="!isLoading">

    <!-- Profile Completion -->
    <nb-card class="profile-card glass-card">
      <nb-card-header>
        <nb-icon icon="pie-chart-outline" status="info"></nb-icon>
        <span>Profile Completion</span>
      </nb-card-header>

      <nb-card-body>
        <nb-progress-bar [value]="profileCompletion" [status]="profileCompletion >= 80 ? 'success' : 'info'">
        </nb-progress-bar>

        <!-- ✅ Animated number -->
        <div class="text-muted mt-2">{{ animatedCompletion }}% completed</div>
      </nb-card-body>
    </nb-card>

    <!-- Basic Info -->
    <nb-card class="profile-card glass-card">
      <nb-card-header>
        <nb-icon icon="person-outline" status="primary"></nb-icon>
        <span>Basic Info</span>
      </nb-card-header>

      <nb-card-body>
        <div class="profile-header">

          <div class="profile-photo-wrapper clickable"
            (click)="profileData?.profileImage && openImagePreview(profileData.profileImage)">
            <img *ngIf="profileData?.profileImage" [src]="profileData.profileImage" alt="Profile">
            <div *ngIf="!profileData?.profileImage" class="avatar-fallback">
              {{ initials }}
            </div>
          </div>


          <div *ngIf="isEditMode" class="mt-2">
            <input type="file" accept="image/*" (change)="onProfilePhotoSelected($event)">
            <small class="text-muted">Upload Profile Picture</small>
          </div>

          <div class="profile-meta">
            <div class="title-text">
              {{ profileData.firstName }} {{ profileData.lastName }}
            </div>

            <div class="subtitle-text">
              <nb-icon icon="briefcase-outline"></nb-icon>
              {{ companyName }}
            </div>

            <!-- Role / status -->
            <div class="badge-row">
              <nb-badge [text]="profileData.role || 'user'" style="
    position: relative;
"
                [status]="profileData.role === 'super-admin' ? 'danger' : (profileData.role === 'admin' ? 'info' : 'basic')">
              </nb-badge>

              <nb-badge [text]="profileData.status || 'notApproved'" style="
    position: relative;
"
                [status]="(profileData.status || '').toLowerCase() === 'approved' ? 'success' : 'warning'">
              </nb-badge>
            </div>



          </div>
        </div>

        <div class="row mt-3">
          <div class="col-md-6 mb-3">
            <div class="float-field">
              <input nbInput fullWidth placeholder=" " name="firstName" [(ngModel)]="profileData.firstName"
                [disabled]="!isEditMode" (ngModelChange)="dataChanged(); calculateCompletion(true)">
              <label>First Name</label>
            </div>
          </div>

          <div class="col-md-6 mb-3">
            <div class="float-field">
              <input nbInput fullWidth placeholder=" " name="lastName" [(ngModel)]="profileData.lastName"
                [disabled]="!isEditMode" (ngModelChange)="dataChanged(); calculateCompletion(true)">
              <label>Last Name</label>
            </div>
          </div>

          <div class="col-md-6 mb-3">
      <div class="float-field">
  <input
    nbInput
    fullWidth
    placeholder=" "
    [(ngModel)]="profileData.department"
    [disabled]="!isEditMode || !canEditRoleDepartment"
    (ngModelChange)="dataChanged(); calculateCompletion(true)"
  />
  <label>Department</label>

  <small class="text-muted" *ngIf="isEditMode && !canEditRoleDepartment">
    Only Super Admin or HR can edit department
  </small>
</div>

          </div>

          <div class="col-md-6 mb-3">
   <div class="float-field">
  <input
    nbInput
    fullWidth
    placeholder=" "
    [(ngModel)]="profileData.position"
    [disabled]="!isEditMode || !canEditRoleDepartment"
    (ngModelChange)="dataChanged(); calculateCompletion(true)"
  />
  <label>Position</label>

  <small class="text-muted" *ngIf="isEditMode && !canEditRoleDepartment">
    Only Super Admin or HR can edit role
  </small>
</div>

          </div>
        </div>
      </nb-card-body>
    </nb-card>

    <!-- Contacts -->
    <nb-card class="profile-card glass-card">
      <nb-card-header>
        <nb-icon icon="phone-outline" status="success"></nb-icon>
        <span>Contacts</span>
      </nb-card-header>

      <nb-card-body>
        <div class="contact-meta">
          <nb-icon icon="email-outline"></nb-icon>
          <div>
            <div>
              {{ profileData.email }}
              <button nbButton ghost size="tiny" (click)="copyToClipboard(profileData.email)">
                <nb-icon icon="copy-outline"></nb-icon>
              </button>
            </div>
          </div>
        </div>

        <div class="mt-3">
          <div class="float-field mb-3">
            <input nbInput fullWidth placeholder=" " name="phone" [(ngModel)]="profileData.phone"
              [disabled]="!isEditMode" (ngModelChange)="dataChanged(); calculateCompletion(true)">
            <label>Phone</label>
          </div>

          <!-- 🔒 Email always disabled -->
          <div class="float-field mb-3">
            <input nbInput fullWidth placeholder=" " name="email" [(ngModel)]="profileData.email" disabled>
            <label>Email</label>
          </div>

          <div class="float-field mb-3">
            <input nbInput fullWidth placeholder=" " name="domainUsername" [(ngModel)]="profileData.domainUsername"
              [disabled]="!isEditMode" (ngModelChange)="dataChanged(); calculateCompletion(true)">
            <label>Domain Username</label>
          </div>
        </div>
      </nb-card-body>
    </nb-card>

    <!-- Address -->
    <nb-card class="profile-card glass-card">
      <nb-card-header>
        <nb-icon icon="map-outline" status="info"></nb-icon>
        <span>Address</span>
      </nb-card-header>

      <nb-card-body>
        <div class="address-meta">
          {{ profileData.address }}, {{ profileData.city }}, {{ profileData.state }}, {{ profileData.country }}
        </div>

        <div class="mt-3">
          <div class="float-field mb-3">
            <input nbInput fullWidth placeholder=" " [(ngModel)]="profileData.country" [disabled]="!isEditMode"
              (ngModelChange)="dataChanged(); calculateCompletion(true)">
            <label>Country</label>
          </div>

          <div class="float-field mb-3">
            <input nbInput fullWidth placeholder=" " [(ngModel)]="profileData.city" [disabled]="!isEditMode"
              (ngModelChange)="dataChanged(); calculateCompletion(true)">
            <label>City</label>
          </div>

          <div class="float-field mb-3">
            <input nbInput fullWidth placeholder=" " [(ngModel)]="profileData.state" [disabled]="!isEditMode"
              (ngModelChange)="dataChanged(); calculateCompletion(true)">
            <label>State/Province/Area</label>
          </div>

          <div class="float-field mb-3">
            <input nbInput fullWidth placeholder=" " [(ngModel)]="profileData.address" [disabled]="!isEditMode"
              (ngModelChange)="dataChanged(); calculateCompletion(true)">
            <label>Address</label>
          </div>

          <div class="float-field mb-3">
            <input nbInput fullWidth type="number" onwheel="this.blur()" placeholder=" " [(ngModel)]="profileData.zipCode"
              [disabled]="!isEditMode" (ngModelChange)="dataChanged(); calculateCompletion(true)">
            <label>Zip Code</label>
          </div>
        </div>
      </nb-card-body>
    </nb-card>

  </div>
</div>
<div class="image-preview-overlay" *ngIf="isImagePreviewOpen" (wheel)="onWheelZoom($event)"
  (touchstart)="onTouchStart($event)" (touchmove)="onTouchMove($event)" (touchend)="onTouchEnd()"
  (click)="closeImagePreview()">

  <div class="image-preview-container" (click)="$event.stopPropagation()" (pointerdown)="onPointerDown($event)"
    (pointermove)="onPointerMove($event)" (pointerup)="onPointerUp()" (pointercancel)="onPointerUp()"
    (pointerleave)="onPointerUp()">

    <div class="preview-toolbar">
      <button nbButton ghost size="small" (click)="zoomIn()">
        <nb-icon icon="plus-outline"></nb-icon>
      </button>

      <button nbButton ghost size="small" (click)="zoomOut()">
        <nb-icon icon="minus-outline"></nb-icon>
      </button>

      <button nbButton ghost size="small" (click)="rotate()">
        <nb-icon icon="refresh-outline"></nb-icon>
      </button>

      <button nbButton ghost size="small" (click)="downloadImage()">
        <nb-icon icon="download-outline"></nb-icon>
      </button>

      <button nbButton ghost status="basic" size="small" (click)="closeImagePreview()">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </div>

    <img [src]="previewImageSrc" class="image-preview"
      [style.transform]="'translate(' + panX + 'px,' + panY + 'px) scale(' + zoomLevel + ') rotate(' + rotation + 'deg)'"
      alt="Preview">
  </div>
</div>
